module.exports = __webpack_public_path__ + "static/media/MAX-Logo1.4179898a.png";